import React from 'react';
import { useParams } from 'react-router-dom';
import Portfolio from './Portfolio';

const FilteredPortfolio = () => {
  const { template } = useParams();
  return <Portfolio template={template} />;
};

export default FilteredPortfolio;
